import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "lifecycle",
    iconColor: "white",
    text: "AI-assisted end-to-end\n app lifecycle \nmanagement",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerMarketplace",
    iconColor: "white",
    text: "Easy application \nonboarding into the \nmarketplace",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "dollarSign",
    iconColor: "white",
    text: "Helps Telcos to \nmonetize their network \nservices",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_IEAM = {
  styleLeftPanel: { paddingRight: 0 },
  title: "INFOSYS Edge \nApplication Management",
  text: "An intelligent, secure and flexible platform that provides autonomous \nmanagement for applications on the edge.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ENG_102"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_1"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Introduction_01.png",
};
